export default __webpack_public_path__ + "bc5addbc3206191e7cc8d3e6e11b5ede.png";